import Link from "next/link";
import React, { useState } from "react";
import PreferencesModal from "@/Components/CookieConsent/PreferencesModal";

interface LinkType {
  id: number;
  href: string;
  label: string;
}

interface Column {
  id: number;
  title: string;
  links: LinkType[];
}

interface SocialNetwork {
  id: number;
  url: string;
  Title: string;
}

interface Props {
  columns: Column[];
  socialNetworks: SocialNetwork[];
  copy_write_text: string;
  pricacy_policy_link: string;
  terms_link: string;
}

const FooterLink: React.FC< Props> = ({ columns,
  socialNetworks,
  copy_write_text,
  pricacy_policy_link,
  terms_link,
 }) => {
  const [showPreferences, setShowPreferences] = useState(false);

  return (
    <div>
      <div className="xl:py-[60px] py-[40px] border-b border-border/30">
        <div className="flex justify-between items-start xl:flex-row flex-col xl:gap-0 gap-10">
          <div className="flex justify-start items-start w-full xl:gap-0 lg:gap-0 gap-10 lg:flex-nowrap flex-wrap">
            {columns.map((column, index) => (
              <div
                key={column.id}
                className={`sm:w-[calc(50%_-_20px)] w-full ${index === 1 ? "xl:min-w-[394px] lg:min-w-[334px]" : "xl:min-w-[227px] lg:min-w-[174px]"}`}
              >
                <h5 className="text-subtitle-2 font-bold text-primary-text-white">
                  {column.title}
                </h5>
                <ul className="mt-5">
                  {column.links.map((item) => (
                    <li
                      key={item.id}
                      className="mt-4 text-subtitle-3 font-regular text-secondary-text-white"
                    >
                      <a href={item?.href}>
                        {item?.label}
                        {item.href == "/careers" ? (
                          <>
                            <span className="ml-[12px] text-[12px] pt-[5px] pb-[1px] px-[6px] text-white font-medium bg-gradient-to-br from-[#0086E6] via-[#8ABC00] to-[#6BCB77] bg-[length:300%_300%] animate-gradient-diagonal">
                              We are Hiring!
                            </span>

                            <style jsx>
                              {`
                                @keyframes gradient-diagonal {
                                  0% { background-position: 0% 0%; }
                                  50% { background-position: 100% 100%; }
                                  100% { background-position: 0% 0%; }
                                }

                                .animate-gradient-diagonal {
                                  animation: gradient-diagonal 5s ease-in-out infinite;
                                }
                              `}
                            </style>

                          </>
                        ) : (
                          <></>
                        )}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="w-[152px] flex-[0_0_auto]">
            <ul className="grid grid-cols-3 gap-4">
              <li>
                <Link
                  href={socialNetworks[0]?.url || ""}
                  aria-label="X-Twitter"
                >
                  {/* images/X.svg */}
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="fill-primary-text-white hover:fill-text-button"
                  >
                    <path
                      d="M26.3263 10.0557H29.6998L22.3297 18.4792L31 29.9416H24.2112L18.894 22.9897L12.8099 29.9416H9.43443L17.3174 20.9318L9 10.0557H15.9611L20.7674 16.41L26.3263 10.0557ZM25.1423 27.9224H27.0116L14.9454 11.9688H12.9394L25.1423 27.9224Z"
                    // fill="#0086E6"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <Link
                  href={socialNetworks[1]?.url || ""}
                  aria-label="Instagram"
                  className="stroke-primary-text-white hover:stroke-text-button"
                >
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="stroke-primary-text-white hover:stroke-text-button"
                  >
                    <path
                      d="M16.5 31.6644H23.5C29.3334 31.6644 31.6667 29.331 31.6667 23.4977V16.4977C31.6667 10.6644 29.3334 8.33105 23.5 8.33105H16.5C10.6667 8.33105 8.33337 10.6644 8.33337 16.4977V23.4977C8.33337 29.331 10.6667 31.6644 16.5 31.6644Z"
                      // stroke="white"
                      strokeWidth="1.86666"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M20 24.0817C22.2551 24.0817 24.0833 22.2535 24.0833 19.9984C24.0833 17.7432 22.2551 15.915 20 15.915C17.7448 15.915 15.9166 17.7432 15.9166 19.9984C15.9166 22.2535 17.7448 24.0817 20 24.0817Z"
                      // stroke="white"
                      strokeWidth="1.86666"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M26.5755 14.1644H26.589"
                      // stroke="white"
                      strokeWidth="2.33333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <Link href={socialNetworks[2]?.url || ""} aria-label="Linkedin">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="fill-primary-text-white hover:fill-text-button"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.6693 9.20703C9.86385 9.20703 9.21094 9.85994 9.21094 10.6654C9.21094 11.4708 9.86385 12.1237 10.6693 12.1237C11.4747 12.1237 12.1276 11.4708 12.1276 10.6654C12.1276 9.85994 11.4747 9.20703 10.6693 9.20703ZM7.46094 10.6654C7.46094 8.89345 8.89736 7.45703 10.6693 7.45703C12.4412 7.45703 13.8776 8.89345 13.8776 10.6654C13.8776 12.4373 12.4412 13.8737 10.6693 13.8737C8.89736 13.8737 7.46094 12.4373 7.46094 10.6654ZM7.46094 16.4987C7.46094 16.0155 7.85269 15.6237 8.33594 15.6237H13.0026C13.4858 15.6237 13.8776 16.0155 13.8776 16.4987V31.6654C13.8776 32.1486 13.4858 32.5404 13.0026 32.5404H8.33594C7.85269 32.5404 7.46094 32.1486 7.46094 31.6654V23.4987C7.46094 23.0155 7.85269 22.6237 8.33594 22.6237C8.81918 22.6237 9.21094 23.0155 9.21094 23.4987V30.7904H12.1276V17.3737H9.21094V18.832C9.21094 19.3153 8.81918 19.707 8.33594 19.707C7.85269 19.707 7.46094 19.3153 7.46094 18.832V16.4987ZM15.6276 16.4987C15.6276 16.0155 16.0194 15.6237 16.5026 15.6237H21.1693C21.6504 15.6237 22.0412 16.0121 22.0443 16.4932L22.0508 17.5464L22.9714 16.7772C23.8632 16.032 24.9885 15.6237 26.1507 15.6237H26.4193C29.802 15.6237 32.5443 18.3659 32.5443 21.7487V31.6654C32.5443 32.1486 32.1525 32.5404 31.6693 32.5404H27.0026C26.5194 32.5404 26.1276 32.1486 26.1276 31.6654V24.6654C26.1276 23.5378 25.2135 22.6237 24.0859 22.6237C22.9584 22.6237 22.0443 23.5378 22.0443 24.6654V31.6654C22.0443 32.1486 21.6525 32.5404 21.1693 32.5404H16.5026C16.0194 32.5404 15.6276 32.1486 15.6276 31.6654V16.4987ZM17.3776 17.3737V30.7904H20.2943V24.6654C20.2943 22.5713 21.9919 20.8737 24.0859 20.8737C26.18 20.8737 27.8776 22.5713 27.8776 24.6654V30.7904H30.7943V21.7487C30.7943 19.3324 28.8356 17.3737 26.4193 17.3737H26.1507C25.3987 17.3737 24.6706 17.6379 24.0935 18.12L21.7485 20.0795C21.4886 20.2967 21.1267 20.3444 20.8194 20.2018C20.5121 20.0594 20.3147 19.7523 20.3125 19.4135L20.2998 17.3737H17.3776Z"
                    // fill="#EDEDEE"
                    />
                  </svg>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="pt-6 flex justify-between md:items-center items-start md:flex-row flex-col md:gap-0 gap-6">
        <div>
          <span className="text-subtitle-4 font-regular text-secondary-text-white">
            {copy_write_text || ""}
          </span>
        </div>
        <div className=" flex justify-between items-center gap-4">
          <Link
            href="/vendor-registration"
            className="text-subtitle-4 font-regular text-secondary-text-white"
          >
            Vendor Registration
          </Link>
          <Link
            href={terms_link || ""}
            className="text-subtitle-4 font-regular text-secondary-text-white"
          >
            Terms & Conditions
          </Link>
          <Link
            href={pricacy_policy_link || ""}
            className="text-subtitle-4 font-regular text-secondary-text-white"
          >
            Privacy Policy
          </Link>
          <button
            onClick={() => setShowPreferences(true)}
            className="text-subtitle-4 font-regular text-secondary-text-white hover:text-text-button transition-colors"
          >
            Cookie Settings
          </button>
          <Link
            href="/sitemap.xml"
            className="text-subtitle-4 font-regular text-secondary-text-white"
          >
            Site map
          </Link>
        </div>
      </div>

      {/* Cookie Preferences Modal */}
      {showPreferences && (
        <PreferencesModal onClose={() => setShowPreferences(false)} />
      )}
    </div>
  );
};
export default FooterLink;